define('Store.Item.Stock.Helper', [
    'underscore',
    'Utils'
], function StoreStockHelper(
    _,
    Utils
) {
    'use strict';

    var stockableItemTypes = [
        'InvtPart'
    ];

    var STOCK_STATUSES = {
        allow: [
            'Allow back orders but display out-of-stock message',
            'Allow back orders with no out-of-stock message'
        ],
        disallow: [
            'Disallow back orders but display out-of-stock message',
            'Remove item when out-of-stock'
        ]
    };

    var STOCK_MESSAGES = {
        show: [
            'Allow back orders but display out-of-stock message',
            'Disallow back orders but display out-of-stock message',
            'Remove item when out-of-stock'

        ],
        hide: [
            'Allow back orders with no out-of-stock message'
        ]
    };

    var STOCKPROPS;


    function getStockSettings() {
        var outOfStockBehavior;
        if (!STOCKPROPS) {
            if (SC && SC.ENVIRONMENT && SC.ENVIRONMENT.siteSettings) {
                outOfStockBehavior = SC.ENVIRONMENT.siteSettings.order.outofstockbehavior;
            } else {
                // eslint-disable-next-line no-undef
                outOfStockBehavior = nlapiGetWebContainer().getShoppingSession().getSiteSettings(['order']).order.outofstockbehavior;
            }

            if (outOfStockBehavior === 'REMOVE') {
                STOCK_STATUSES.disallow.push('- Default -');
                STOCK_MESSAGES.show.push('- Default -');
            } else {
                STOCK_STATUSES.allow.push('- Default -');
                STOCK_MESSAGES.hide.push('- Default -');
            }

            STOCKPROPS = {
                STOCK_MESSAGES: STOCK_MESSAGES,
                STOCK_STATUSES: STOCK_STATUSES
            };
        }
        return STOCKPROPS;
    }

    /**
     * this helper is to be able to use backbone models in frontend
     and raw objects in backend.
     Keeping 1 one logic file, which makes PZ very happy
     */
    function safePropRead(obj, key) {
        if (obj && key) {
            if (_.isFunction(obj.get) && _.isObject(obj.attributes)) {
                return obj.get(key);
            }
            return obj[key];
        }
        return undefined;
    }

    function safePropSet(obj, key, value) {
        if (obj && key) {
            if (_.isFunction(obj.set) && _.isObject(obj.attributes)) {
                obj.set(key, value);
            }
            obj[key] = value;
        }
    }

    function itemAllowsBackorders(item) {
        return getStockSettings().STOCK_STATUSES.allow.indexOf(safePropRead(item, 'outofstockbehavior')) !== -1;
    }

    function itemShowsOutOfStockMessage(item) {
        return getStockSettings().STOCK_MESSAGES.show.indexOf(safePropRead(item, 'outofstockbehavior')) !== -1;
    }

    function isStockableItem(item) {
        return stockableItemTypes.indexOf(safePropRead(item, 'itemtype')) !== -1;
    }

    function getStoresAvailable(item) {
        var storeInfo = safePropRead(item, 'custitem_sca_store') || '';
        return _.map(_.compact(_.uniq(storeInfo.split(','))), function eachStoreName(s) {
            return (s || '').trim();
        }) || [];
    }

    function itemIsAvailableInStore(item, store) {
        var stores = getStoresAvailable(item);
        return stores.indexOf(safePropRead(store, 'name')) !== -1;
    }

    return {
        getStockSettings: getStockSettings,
        _isStockable: function _isStockable(item) {
            return isStockableItem(item);
        },
        _hideFromWebstore: function _removeFromStore(item, store) {
            return !this._soldInStore(item, store) || (
                !this._isInStock(item, store) &&
                safePropRead(item, 'outofstockbehavior') === 'Remove item when out-of-stock'
            );
        },
        _outOfStockMessage: function _outOfStockMessage(item, store) {
            if (!itemIsAvailableInStore(item, store)) {
                return this._notSoldInStoreMessage(item, store);
            }
            return safePropRead('item', 'outofstockmessage2') || safePropRead('item', 'outofstockmessage') || Utils.translate('Out Of Stock');
        },
        _notSoldInStoreMessage: function _notSoldInStoreMessage(item, store) {
            if (itemIsAvailableInStore(item, store)) {
                return '';
            }
            return Utils.translate('Item not currently available in $(0)', store.get('name'));
        },
        _soldInStore: function _soldInStore(item, store) {
            return itemIsAvailableInStore(item, store);
        },
        _stock: function storeStock(item, store) {
            var keyForCache = '_qty_cache_store' + safePropRead(store, 'internalid');
            var cachePropValue = safePropRead(item, keyForCache);
            var storeItemLocations;
            var stockForStore;
            var invtDetail;
            var saleConversion;

            if (typeof cachePropValue !== 'undefined') {
                return cachePropValue;
            }

            storeItemLocations = safePropRead(store, 'locations');
            stockForStore = 0;
            invtDetail = safePropRead(item, 'quantityavailable_detail');
            saleConversion = safePropRead(item, 'custitem_uom_saleconversion');

            if (!isStockableItem(item)) {
                return undefined;
            }

            if (!invtDetail || !invtDetail.locations || !invtDetail.locations.length) {
                return 0;
            }

            stockForStore = _.reduce(invtDetail.locations, function red(stockAccumulation, value) {
                if (storeItemLocations.indexOf(value.internalid) !== -1) {
                    return stockAccumulation + value.quantityavailable;
                }
                return stockAccumulation;
            }, stockForStore);

            if (saleConversion && saleConversion > 0) {
                stockForStore = Math.floor(stockForStore / saleConversion);
            }

            safePropSet(item, keyForCache, stockForStore);

            return stockForStore;
        },
        _isInStock: function _isInStock(item, store) {
            return this._isPurchasable(item, store) && this._stock(item, store) > 0;
        },
        _isPurchasable: function _isPurchasable(item, store) {
            var stock;
            var originalValue = safePropRead(item, 'ispurchasable');

            if (!itemIsAvailableInStore(item, store)) {
                return false;
            }

            if (!isStockableItem(item)) {
                return originalValue;
            }

            if (itemAllowsBackorders(item)) {
                return originalValue;
            }

            stock = this._stock(item, store);
            return originalValue && (stock > 0);
        },
        _showOutOfStockMessage: function _showOutOfStockMessage(item, store) {
            if (!isStockableItem(item)) {
                return false;
            }
            if (!itemIsAvailableInStore(item, store)) {
                return true;
            }

            if (itemShowsOutOfStockMessage(item)) {
                return !this._isInStock(item, store);
            }
            return false;
        }
    };
});
